export { default as Img200 } from './processed/200/Stargate-Atlantis-cast-s5.jpg';
export { default as Img400 } from './processed/400/Stargate-Atlantis-cast-s5.jpg';
export { default as Imgthumb } from './processed/thumb/Stargate-Atlantis-cast-s5.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Stargate-Atlantis-cast-s5.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Stargate-Atlantis-cast-s5.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      116,
      54,
      71
    ],
    "_population": 23,
    "_hsl": [
      0.9543010752688171,
      0.3647058823529412,
      0.3333333333333333
    ]
  },
  "LightVibrant": {
    "_rgb": [
      206,
      221,
      236
    ],
    "_population": 328,
    "_hsl": [
      0.5833333333333334,
      0.4411764705882355,
      0.8666666666666667
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      72,
      33,
      46
    ],
    "_population": 7,
    "_hsl": [
      0.9444444444444445,
      0.3714285714285714,
      0.20588235294117646
    ]
  },
  "Muted": {
    "_rgb": [
      116,
      144,
      174
    ],
    "_population": 2232,
    "_hsl": [
      0.5862068965517241,
      0.26363636363636367,
      0.5686274509803921
    ]
  },
  "LightMuted": {
    "_rgb": [
      148,
      174,
      195
    ],
    "_population": 2606,
    "_hsl": [
      0.5744680851063829,
      0.2814371257485028,
      0.6725490196078432
    ]
  },
  "DarkMuted": {
    "_rgb": [
      43,
      58,
      78
    ],
    "_population": 44,
    "_hsl": [
      0.5952380952380952,
      0.2892561983471074,
      0.23725490196078433
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Stargate-Atlantis-cast-s5.js